module.exports = __webpack_public_path__ + "img/standard-blanc.98173cc1.png";